import api from "../../services/api";

// cache module-level do catálogo de slots, com pub/sub: N linhas × M abas
// custam 1 requisição só

let slots = null;
let carregando = null;
let erro = null;
const inscritos = new Set();

function notificar() {
    for (const fn of inscritos) fn();
}

export function getSnapshot() {
    return { slots, erro, carregando: Boolean(carregando) };
}

export function subscribe(fn) {
    inscritos.add(fn);
    return () => inscritos.delete(fn);
}

export function carregarSlots({ force = false } = {}) {
    if (!force && slots) return Promise.resolve(slots);
    if (!force && carregando) return carregando;

    erro = null;
    notificar();

    carregando = api
        .post("/schema/getSlotsMetrica", {})
        .then((response) => {
            slots = response?.data?.slots || [];
            return slots;
        })
        .catch((e) => {
            erro = e;
            throw e;
        })
        .finally(() => {
            carregando = null;
            notificar();
        });

    return carregando;
}

function substituirLista(proxima) {
    slots = proxima;
    notificar();
}

export async function criarSlot({ key, label, aba, descricao }) {
    const response = await api.post("/schema/postSlotMetrica", {
        key,
        label,
        aba,
        descricao,
    });

    const criado = response?.data?.slot;
    if (!criado) return null;

    const atuais = slots || [];
    const jaTem = atuais.some((slot) => slot.id === criado.id);
    substituirLista(jaTem
        ? atuais.map((slot) => (slot.id === criado.id ? criado : slot))
        : [...atuais, criado]);

    return { slot: criado, created: Boolean(response?.data?.created) };
}

export async function atualizarSlot({ id, label, descricao, key, aba }) {
    const response = await api.put("/schema/putSlotMetrica", {
        id,
        label,
        descricao,
        key,
        aba,
    });

    const atualizado = response?.data?.slot;
    if (!atualizado) return null;

    substituirLista(
        (slots || []).map((slot) => (slot.id === atualizado.id ? atualizado : slot)),
    );

    return atualizado;
}

export async function excluirSlot({ id, force = false }) {
    await api.post("/schema/deleteSlotMetrica", { id, force });
    substituirLista((slots || []).filter((slot) => slot.id !== id));
}

export function invalidarSlots() {
    slots = null;
    carregando = null;
    erro = null;
    notificar();
}
